exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".bqvRa {\n  font-family: \"Cormorant Garamond\", \"Noto Serif\", \"Georgia\", \"Times\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  font-weight: bold;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  margin-bottom: 0;\n  text-transform: uppercase;\n  text-align: center;\n  color: #BD9471;\n  background-color: #404242;\n}\n", ""]);

// Exports
exports.locals = {
	"modalTitle": "bqvRa"
};